var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6832 14.0188V8.79813C13.6832 7.79656 13.3232 6.94523 12.6033 6.24413C11.8834 5.54303 11.0092 5.19249 9.98071 5.19249C8.95225 5.19249 8.07805 5.54303 7.35812 6.24413C6.6382 6.94523 6.27823 7.79656 6.27823 8.79813V14.0188H13.6832ZM15.3416 13.1925L17 14.8075V15.5962H3V14.8075L4.6584 13.1925V8.79813C4.6584 7.57121 5.04407 6.49453 5.81542 5.56807C6.58677 4.61659 7.56382 4.00313 8.74655 3.7277V3.20188C8.74655 2.85132 8.86225 2.56337 9.09366 2.33803C9.35077 2.11268 9.64646 2 9.98071 2C10.3407 2 10.6364 2.11268 10.8678 2.33803C11.0991 2.56337 11.2149 2.85132 11.2149 3.20188V3.7277C12.4233 4.00313 13.4132 4.61659 14.1845 5.56807C14.9559 6.49453 15.3416 7.57121 15.3416 8.79813V13.1925ZM9.98071 18C9.54361 18 9.15794 17.8372 8.82369 17.5117C8.51515 17.2113 8.36088 16.8482 8.36088 16.4226H11.6391C11.6391 16.8482 11.472 17.2113 11.1377 17.5117C10.8292 17.8372 10.4436 18 9.98071 18Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/icon_alarm.51103882e49ec404e4f96ec92e510d2a.svg";
export { ForwardRef as ReactComponent };